import React from 'react';

export const SvgVolumeUp = props => (
  <svg viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14 4.652v-.2c0-.63.63-1.08 1.21-.85a8.98 8.98 0 015.79 8.4c0 3.84-2.4 7.11-5.79 8.4-.58.22-1.21-.22-1.21-.85v-.2c0-.38.24-.71.6-.85a7.004 7.004 0 004.4-6.5c0-2.94-1.82-5.47-4.4-6.5a.93.93 0 01-.6-.85zm-11 5.35v4c0 .55.45 1 1 1h3l3.29 3.29c.63.63 1.71.18 1.71-.71V6.412c0-.89-1.08-1.34-1.71-.71L7 9.002H4c-.55 0-1 .45-1 1zm13.5 2a4.5 4.5 0 00-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02z"
      fill="currentColor"
    />
  </svg>
);
